module.exports = __webpack_public_path__ + "img/project3@2x.bba59749.webp";